module.exports = __webpack_public_path__ + "static/media/nestje3.31ac685e.webp";